<template>
    <a-modal 
        v-model="modalVisible"
        :title="title" 
        :ok-text="okText" 
        :cancel-text="cancelText" 
        @ok="okCallback"
        @cancel="cancelCallback"
        :maskClosable="false"
        :closable="false"
        :centered="true"
        :maskStyle="{backgroundColor: 'rgba(0, 0, 0, 0.2)'}"
        :dialogClass="msgClass"
        :okButtonProps="{ style: !okText ? { display: 'none' } : {} }"
        :cancelButtonProps="{ style: !cancelText ? { display: 'none' } : {} }"
    >
    <slot></slot>
    </a-modal>
</template>

<script>
    export default {
        name: 'ModalApiResultMsg',
        props: {
            visible: Boolean,
            title: String, 
            okText: String,
            cancelText: String,
            msgClass: String,
            okCallback: Function,
            cancelCallback: Function,
        },
        data() {
            return {
                modalVisible: false,
            }
        },
        watch: {
            visible() {
                this.modalVisible = this.visible;
            }
        }
    }
</script>
